import { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import { useLoading } from "../../../components/Loading";
import { useSnackbar } from "../../../context/popup";

const ViewMotorRTO = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [rtoData, setRTOData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/RTO/${paramId}`).then(
            (res) => {
              setRTOData((prevData) => ({
                ...prevData,
                ...res?.data,
              }));
            }
          );
        } catch (error) {
          console.error(error);
          showSnackbar(error?.response?.data?.message, "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  return (
    <DashboardLayout>
      <Box
        sx={{
          padding: { xs: 2, md: 2 },
          bgcolor: "#f9f9f9",
          minHeight: "100vh",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="left"
          spacing={1}
          mb={2}
        >
          <IconButton onClick={() => navigate("/motor-master/motor-RTO")}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
            Motor RTO Information
          </Typography>
        </Stack>

        {rtoData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {rtoData?.name}
                  </Typography>
                  <TextContainerField
                    label="RTO ID"
                    value={rtoData?.id}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Display Name"
                    value={rtoData?.displayName}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="RTO Code"
                    value={rtoData?.rtocode}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="RTO Region"
                    value={rtoData?.rtoRegion?.keyName}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="RTO Zone"
                    value={rtoData?.rtoZone?.keyName}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="City"
                    value={rtoData?.city?.name}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="District"
                    value={rtoData?.city?.district?.name}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="State"
                    value={rtoData?.city?.district?.state?.name}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Status"
                    value={rtoData?.isActive ? "Active" : "Inactive"}
                    labelStyle={{ fontWeight: "500" }}
                  />
                  <TextContainerField
                    label="Updated At"
                    value={rtoData?.updatedAt}
                    labelStyle={{ fontWeight: "500" }}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        ) : (
          <Box>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                color: "red",
                fontFamily: "cursive",
              }}
            >
              No RTO Data Found
            </Typography>
          </Box>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default ViewMotorRTO;
